/* eslint-disable */
function _typeof (e) {
  return (_typeof =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (e) {
          return typeof e
        }
      : function (e) {
          return e &&
            'function' == typeof Symbol &&
            e.constructor === Symbol &&
            e !== Symbol.prototype
            ? 'symbol'
            : typeof e
        })(e)
}
var ku_translations = {
    en: {
      viewAll: 'View All',
      ProductResults: 'Products Results',
      articles: 'Pages',
      products: 'Products',
      blog: 'Blog Articles',
      filterBy: 'Refine By',
      apply: 'Apply Filters & Close',
      youMayAlsoLike: 'You May Also Like',
      noCMS: 'No suitable articles found.',
      noProducts: 'No suitable products found.'
    }
  },
  klevu_enableLandingAutoScroll = !0,
  klevu_uc = {
    showAutocompleteProducts: function (e) {
      var t,
        a,
        o = '',
        s = document.createElement('div'),
        l = !!e.additionalDataToReturn && JSON.parse(e.additionalDataToReturn)
      if (
        (((e = klevu_productCustomizations(e)).additionalFlags = l),
        0 === e.productImage.trim().length &&
          (e.productImage = klevu_userOptions.noImageUrl),
        klevu_userOptions.openProductClicksInNewWindow
          ? (additionalParams = ' target="_blank"')
          : (additionalParams =
              ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"'),
        (t =
          "{data: {code: '" +
          escape(e.productCode) +
          "',url: '" +
          escape(e.productUrl) +
          "',name: '" +
          escape(e.productName) +
          "',salePrice: '" +
          escape(e.salePrice) +
          "',rating: '" +
          escape(e.rating) +
          "',position: " +
          e.productPosition +
          ",category: '" +
          escape(e.category) +
          "',sku: '" +
          escape(e.sku) +
          "'}}"),
        (s.innerHTML = e.productName),
        (a = s.textContent || s.innerText || ''),
        (o += '<li>'),
        (o +=
          '<a href="' +
          e.productUrl.replace(/"/g, '%22') +
          '" class="klevu-result-box-l2" '),
        klevu_commons.isMobileDevice()
          ? (o +=
              ' onclick="return  klevu_analytics.trackClickedProduct(event, ' +
              t +
              ');" target="_self" >')
          : (o +=
              ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' +
              t +
              ');"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
              t +
              ', klevu_analytics.trackClickedProduct);" ' +
              additionalParams +
              ' >'),
        (o +=
          '<div class="klevu-img-wrap-l2"><img src="' +
          e.productImage +
          '" onerror="this.onerror=null;this.src=\'' +
          klevu_userOptions.noImageUrl +
          '\';" alt="' +
          klevu_commons.escapeHtml(a) +
          '" /></div>'),
        'undefined' != typeof klevu_showDiscountBadge &&
          klevu_showDiscountBadge &&
          '' != e.discount &&
          '0' != e.discount &&
          '0.0' != e.discount &&
          (-1 === klevu_uiLabels.discountBadgeText.indexOf('#')
            ? (o +=
                '<div class="klevu-discount-badge-l2">' +
                klevu_uiLabels.discountBadgeText +
                ' ' +
                Number(e.discount).toFixed(0) +
                '%</div>')
            : (o +=
                '<div class="klevu-discount-badge-l2">' +
                klevu_uiLabels.discountBadgeText.replace(
                  '#',
                  Number(e.discount).toFixed(0) + '%'
                ) +
                '</div>')),
        (o += '<div class="klevu-name-desc-l2">'),
        (o +=
          '<div class="klevu-name-l2">' +
          e.productName +
          '</div><div class="klevu-desc-l2">' +
          e.productDescription +
          '</div>'),
        klevu_showPrices)
      ) {
        o += '<div class="klevu-price-l2">'
        try {
          void 0 !== e.tags &&
          '' !== e.tags &&
          -1 !== e.tags.indexOf('klevu-poa')
            ? (o += '<div class="ku-poa-price">POA</div>')
            : (o += klevu_productElements.showPrices(e))
        } catch (e) {
          console.log(e)
        }
        klevu_userOptions.vatCaption.trim().length > 0 &&
          (o +=
            '<span class="klevu-vat-caption-l2">(' +
            klevu_userOptions.vatCaption +
            ')</span>'),
          (o += '</div>')
      }
      return (
        (o += klevu_productElements.showRating(e)),
        klevu_userOptions.outOfStockCaption.trim().length > 0 &&
          e.inStock &&
          'no' === e.inStock &&
          (o +=
            '<div class="klevu-out-of-stock-l2">' +
            klevu_userOptions.outOfStockCaption +
            '</div>'),
        (o += '</div><div class="klevu-clear-left"></div></a></li>')
      )
    },
    showLandingPageData: function (e) {
      console.log(e)
      var t,
        l,
        n,
        r,
        a,
        i,
        s = '',
        o = '',
        u = document.getElementById('searchedKeyword').value,
        c = '',
        d = 0,
        v = 0,
        k = 0,
        m = !1,
        g = '',
        p = 5,
        y = !0,
        h = '',
        _ = document.createElement('div'),
        f = !!e.additionalDataToReturn && JSON.parse(e.additionalDataToReturn)
      ;((e = klevu_productCustomizations(e)).additionalFlags = f),
        0 === e.productImage.trim().length &&
          (e.productImage = klevu_userOptions.noImageUrl),
        (o = klevu_userOptions.openProductClicksInNewWindow
          ? ' target="_blank"'
          : ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"'),
        (t =
          "{data: {code: '" +
          escape(e.productCode) +
          "',url: '" +
          escape(e.productUrl) +
          "',name: '" +
          escape(e.productName) +
          "',salePrice: '" +
          escape(e.salePrice) +
          "',rating: '" +
          escape(e.rating) +
          "',position: " +
          e.productPosition +
          ",category: '" +
          escape(e.category) +
          "',sku: '" +
          escape(e.sku) +
          "'},apiKey: null,keywordsLP: '" +
          escape(u) +
          "'}"),
        (c = klevu_commons.isMobileDevice()
          ? ' onclick="return klevu_analytics.trackClickedProduct(event, ' +
            t +
            ');" target="_self">'
          : ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' +
            t +
            ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
            t +
            ', klevu_analytics.trackClickedProduct);" ' +
            o +
            '>')
      try {
        s += '<li>'
        s += `<a href="${e.productUrl.replace(
          /"/g,
          '%22'
        )}" class="prd-Card prd-Card-grid">`
        s += `<div class="prd-Card_ImageContainer">`
        if (e.imageHover) {
          const productImage =
            e.productImage.indexOf('_400x800.jpg') >= 0
              ? e.productImage.replace('_400x800.jpg', '_900x.jpg')
              : e.productImage
          s += `<div class="prd-Card_Image"><div class="rsp-Image rsp-Image-contain" style="--Image_AspectRatio: 100.0%;"><img src="${productImage}" class="rsp-Image_Image" onerror="this.onerror=null;this.src='${
            klevu_userOptions.noImageUrl
          }';" alt="${klevu_commons.escapeHtml(e.productName)}"/></div></div>`
          const hoverImage =
            e.imageHover.indexOf('_400x800.jpg') >= 0
              ? e.imageHover.replace('_400x800.jpg', '_900x.jpg')
              : e.imageHover
          s += `<div class="prd-Card_ImageHover"><div class="rsp-Image rsp-Image-contain" style="--Image_AspectRatio: 100.0%;"><img src="${hoverImage}" class="rsp-Image_Image" alt="${klevu_commons.escapeHtml(
            e.productName
          )}" /></div></div>`
        } else {
          const productImage =
            e.productImage.indexOf('_400x800.jpg') >= 0
              ? e.productImage.replace('_400x800.jpg', '_900x.jpg')
              : e.productImage
          s += `<div class="prd-Card_Image prd-Card_Image-single"><div class="rsp-Image rsp-Image-contain" style="--Image_AspectRatio: 100.0%;"><img src="${productImage}" class="rsp-Image_Image" onerror="this.onerror=null;this.src='${
            klevu_userOptions.noImageUrl
          }';" alt="${klevu_commons.escapeHtml(e.productName)}"/></div></div>`
        }
        s += '</div>'
      } catch (e) {}
      if (
        typeof klevu_showDiscountBadge !== 'undefined' &&
        klevu_showDiscountBadge &&
        e.discount != '' &&
        e.discount != '0' &&
        e.discount != '0.0'
      ) {
        if (klevu_uiLabels.discountBadgeText.indexOf('#') === -1) {
          s += `<div class="kuDiscountBadge">${
            klevu_uiLabels.discountBadgeText
          } ${Number(e.discount).toFixed(0)}%</div>`
        } else {
          s += `<div class="kuDiscountBadge">${klevu_uiLabels.discountBadgeText.replace(
            '#',
            `${Number(e.discount).toFixed(0)}%`
          )}</div>`
        }
      }

      if (e.enable === 'true') {
        s += `<div class="prd-Card_Ar3d" title="${window.theme.strings.product.view_3d}"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 19"><path d="M16.7192 4.05053c.0955.04645.177.12356.2281.22586.0025.00488.0048.00978.0071.0147.0049.01078.0095.02174.0137.03288.0231.06124.0333.12415.032.18609V8c0 .27614-.2238.5-.5.5-.2761 0-.5-.22386-.5-.5V5.30902l-2.2764 1.13819c-.247.1235-.5473.02339-.6708-.2236-.1235-.24699-.0234-.54733.2236-.67082L15.3821 4.5l-2.1056-1.05279c-.247-.12349-.3471-.42383-.2236-.67082.1235-.24699.4238-.3471.6708-.2236l2.9955 1.49774Zm.2809 10.43937c.0015.0734-.0131.1482-.0457.219-.0245.0532-.0582.1019-.0997.1437-.0421.0418-.087.0733-.1355.0969l-2.9955 1.4977c-.247.1235-.5473.0234-.6708-.2236-.1235-.247-.0234-.5473.2236-.6708L15.3821 14.5l-2.1056-1.0528c-.247-.1235-.3471-.4238-.2236-.6708.1235-.247.4238-.3471.6708-.2236l2.2764 1.1382V11c0-.2761.2239-.5.5-.5.2762 0 .5.2239.5.5v3.4899ZM1.61814 14.5l2.10558 1.0528c.24699.1235.3471.4238.2236.6708-.12349.247-.42383.3471-.67082.2236L.28102 14.9495c-.095476-.0465-.176971-.1236-.2281241-.2259-.0024388-.0049-.0047903-.0098-.0070553-.0147-.0049592-.0108-.0095397-.0217-.0137293-.0329-.02306797-.0612-.03330058-.1241-.03200177-.1861V11c0-.2761.22385747-.5.50000047-.5.276142 0 .5.2239.5.5v2.691l2.27639-1.1382c.24699-.1235.54733-.0234.67082.2236.1235.247.02339.5473-.2236.6708L1.61814 14.5Zm-.61803-9.19098V8c0 .27614-.223858.5-.5.5-.276143 0-.50000047-.22386-.50000047-.5V4.51006c-.00153919-.07341.01311637-.14816.04573107-.21897.0244898-.05323.0582134-.10191.0996964-.14364.0421-.04182.086988-.07333.135483-.09692L3.2765 2.55279c.24699-.1235.54733-.02339.67082.2236.1235.24699.02339.54733-.2236.67082L1.61814 4.5l2.10558 1.05279c.24699.12349.3471.42383.2236.67082-.12349.24699-.42383.3471-.67082.2236L1.00011 5.30902ZM8.26751.0572848C8.33699.0207035 8.41613 0 8.50011 0s.16312.0207035.2326.0572848L11.7237 1.55279c.247.12349.3471.42383.2236.67082-.1235.24699-.4238.3471-.6708.2236L9.00011 1.30902V4c0 .27614-.22386.5-.5.5s-.5-.22386-.5-.5V1.30902L5.72372 2.44721c-.24699.1235-.54733.02339-.67082-.2236-.1235-.24699-.02339-.54733.2236-.67082L8.26751.0572848ZM8.73271 18.9427c-.06948.0366-.14862.0573-.2326.0573s-.16312-.0207-.2326-.0573L5.2765 17.4472c-.24699-.1235-.3471-.4238-.2236-.6708.12349-.247.42383-.3471.67082-.2236l2.27639 1.1382V15c0-.2761.22386-.5.5-.5s.5.2239.5.5v2.691l2.27639-1.1382c.247-.1235.5473-.0234.6708.2236.1235.247.0234.5473-.2236.6708l-2.99099 1.4955Zm.2674-10.13368V11.5c0 .2761-.22386.5-.5.5s-.5-.2239-.5-.5V8.80902L5.2765 7.44721c-.24699-.12349-.3471-.42383-.2236-.67082.12349-.24699.42383-.3471.67082-.2236l2.77639 1.38819 2.77639-1.38819c.247-.1235.5473-.02339.6708.2236.1235.24699.0234.54733-.2236.67082L9.00011 8.80902Z" fill="currentColor"/></svg></div>`
      }

      s += `
        <div class="prd-Wishlist">

          <button class="prd-Wishlist_Button prd-Wishlist_Button-add iWishAddColl iwishcheck ${
            window.iWishlistmain && window.iWishlistmain[e.id]
              ? 'iWishAdded'
              : ''
          }"
            onclick="window.wishlist.addToWishlist(this, '${
              e.itemGroupId
            }',''); return false;"
            data-variant="${e.itemGroupId}"
            data-product="${e.id}"
            data-pTitle="${e.productName}"
            data-wishlist-button-add
            title="${window.theme.strings.general.wishlist.add_to_wishlist}"
          >
            <span class="prd-Wishlist_Icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" fill-rule="evenodd" d="M9.192 2.177a4.276 4.276 0 015.231 6.752L8 14.444 1.577 8.929a4.276 4.276 0 015.23-6.752L8 3.008l1.192-.83z" clip-rule="evenodd"/></svg>
            </span>
            <span class="util-ScreenReaderOnly">
              ${window.theme.strings.general.wishlist.add_to_wishlist}
            </span>
          </button>
          <button class="prd-Wishlist_Button prd-Wishlist_Button-remove"
            onclick="window.wishlist.removeFromWishlist(this, '${
              e.itemGroupId
            }',false); return false;"
            data-variant="${e.itemGroupId}"
            data-product="${e.id}"
            data-wishlist-button-remove
            title="${
              window.theme.strings.general.wishlist.remove_from_wishlist
            }"
          >
            <span class="prd-Wishlist_Icon prd-Wishlist_Icon-filled">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" stroke="currentColor" fill-rule="evenodd" d="M9.192 2.177a4.276 4.276 0 015.231 6.752L8 14.444 1.577 8.929a4.276 4.276 0 015.23-6.752L8 3.008l1.192-.83z" clip-rule="evenodd"/></svg>
            </span>
            <span class="util-ScreenReaderOnly">
              ${window.theme.strings.general.wishlist.remove_from_wishlist}
            </span>
          </button>

        </div>
      `
      s += '<div class="prd-Card_Content">'
      if (e.badge) {
        s += `<p class="prd-Card_Kicker fz-12_16">${e.badge}</p>`
      }
      s += `<h3 class="prd-Card_Title fz-12_20">${e.productName}</h3>`
      s += `<ul class="prd-Card_SpecItems fz-14_24">`
      if (e.strapline) {
        s += `<li class="prd-Card_SpecItem">${e.strapline
          .replace('[', '')
          .replace(']', '')}</li>`
      }
      if (e.Case_Size) {
        s += `<li class="prd-Card_SpecItem">Case Size ${e.Case_Size}</li>`
      }
      s += `</ul>`
      s += '<div class="prd-Card_Price fz-14_24">'
      if (e.tags.indexOf('klevu-poa') != -1) {
        s += `<p style="text-align: center;">POA</div>`
      } else {
        if (klevu_showPrices) {
          s += klevu_landingProductElements
            .showPrices(e, 'prd-Price')
            .replace('.00', '')
        }
      }
      s += '</div>'
      s += '</div>'
      if (klevu_commons.showAddToCartButton(e.inStock, e.hideAddToCart)) {
        s += klevu_landingProductElements.showAddtocart(e)
      }
      s += '</a>'
      s += '</li>'
      return s
    },
    showProductPrices: function (e, t, l, n) {
      if (
        'undefined' != typeof klevu_groupListCategory &&
        klevu_groupListCategory &&
        t.hideGroupPrices &&
        -1 !== t.hideGroupPrices.indexOf(klevu_groupListCategory)
      )
        return ''
      var r,
        a,
        i,
        s,
        o,
        u,
        c,
        d,
        v = '',
        k = 0
      if (
        (t.productPrice.indexOf(t.currency) >= 0 && (t.currency = ''),
        '0' === t.productPrice.trim() && (t.productPrice = ''),
        -1 !== klevu_currenciesAppendedAtEnd.indexOf(t.currency) && (o = !0),
        'undefined' != typeof klevu_currentCurrencyCode &&
          klevu_currentCurrencyCode &&
          'undefined' != typeof klevu_currentCurrencyRates &&
          klevu_currentCurrencyRates &&
          klevu_currentCurrencyCode !== t.currency &&
          klevu_currencySymbols[klevu_currentCurrencyCode] !== t.currency &&
          klevu_currentCurrencyRates[klevu_currentCurrencyCode])
      ) {
        var m = 0,
          g = klevu_currentCurrencyRates[klevu_currentCurrencyCode]
        g.split(':').length >= 2 && (m = g.split(':')[0]),
          m > 0 &&
            (t.productPrice &&
              (t.productPrice = (Number(t.productPrice) * m).toString()),
            t.startPrice &&
              (t.startPrice = (Number(t.startPrice) * m).toString()),
            t.toPrice && (t.toPrice = (Number(t.toPrice) * m).toString()),
            t.priceToDisplay &&
              (t.priceToDisplay = (Number(t.priceToDisplay) * m).toString()),
            t.salePrice && (t.salePrice = (Number(t.salePrice) * m).toString()),
            g.split(':')[1].trim().length > 0 && (t.currency = g.split(':')[1]),
            g.split(':').length > 2 && (o = 'true' === g.split(':')[2]))
      }
      if (
        ((d = klevu_userOptions.priceFormatter),
        (!t.priceToDisplay && !t.startPrice && !t.toPrice) ||
          !t.totalProductVariants ||
          '0' === t.totalProductVariants)
      )
        if (
          ((u = Number(t.productPrice).formatMoneyForKlevu(
            d.decimalPlaces,
            '',
            d.thousandSeparator,
            d.decimalSeparator
          )),
          (c =
            '<span class="money">' +
            (c = klevu_commons.addCurrencyToPrice(u, t.currency, o)) +
            '</span>'),
          t.productPrice.trim().length > 0 &&
          t.salePrice.trim().length > 0 &&
          t.productPrice != t.salePrice &&
          '0.00' !== t.productPrice &&
          '0' !== t.productPrice &&
          Number(t.productPrice).toFixed(2) != Number(t.salePrice).toFixed(2)
            ? 'SLIM' === e
              ? ((v += klevu_layout.getPriceDivs('ORIG', c, '')), (l = n))
              : 'BASIC' === e
              ? ((v += klevu_layout.getPriceDivs('ORIG', c, '')), (l = n))
              : 'LANDING' === e &&
                ((v += klevu_getPriceDivs('ORIG', c, '')), (l = n))
            : t.productPrice.trim().length > 0 &&
              '0.00' !== t.productPrice &&
              '0.0' !== t.productPrice &&
              '0' !== t.productPrice &&
              ('SLIM' === e
                ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
                : 'BASIC' === e
                ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
                : 'LANDING' === e &&
                  (v += klevu_getPriceDivs('SALE', c, '', l))),
          t.salePrice.trim().length > 0 &&
            t.productPrice != t.salePrice &&
            0 === t.priceToDisplay.trim().length &&
            '0.00' !== t.salePrice &&
            '0' !== t.salePrice &&
            '0.0' !== t.salePrice &&
            Number(t.productPrice).toFixed(2) != Number(t.salePrice).toFixed(2))
        ) {
          if (((r = t.salePrice), t.groupPrices.trim().length > 0))
            for (
              document.getElementById('klevu_loginCustomerGroup')
                ? (klevu_loginCustomerGroup = document.getElementById(
                    'klevu_loginCustomerGroup'
                  ).innerText)
                : 'undefined' == typeof klevu_loginCustomerGroup &&
                  (klevu_loginCustomerGroup = ''),
                k = 0,
                a = (s = t.groupPrices.split(';')).length;
              k < a;
              k++
            )
              (i = s[k].split(':'))[0].trim() === klevu_loginCustomerGroup &&
                3 === i.length &&
                Number(i[2].trim()) < Number(t.salePrice) &&
                (r = i[2].trim())
          ;(u = Number(r).formatMoneyForKlevu(
            d.decimalPlaces,
            '',
            d.thousandSeparator,
            d.decimalSeparator
          )),
            (c =
              '<span class="money">' +
              (c = klevu_commons.addCurrencyToPrice(u, t.currency, o)) +
              '</span>'),
            'SLIM' === e
              ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'BASIC' === e
              ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'LANDING' === e && (v += klevu_getPriceDivs('SALE', c, '', l))
        } else if (
          t.salePrice.trim().length > 0 &&
          0 === t.priceToDisplay.trim().length &&
          '0.00' !== t.salePrice &&
          '0' !== t.salePrice &&
          '0.0' !== t.salePrice
        ) {
          if (((r = t.salePrice), t.groupPrices.trim().length > 0))
            for (
              document.getElementById('klevu_loginCustomerGroup')
                ? (klevu_loginCustomerGroup = document.getElementById(
                    'klevu_loginCustomerGroup'
                  ).innerText)
                : 'undefined' == typeof klevu_loginCustomerGroup &&
                  (klevu_loginCustomerGroup = ''),
                k = 0,
                a = (s = t.groupPrices.split(';')).length;
              k < a;
              k++
            )
              (i = s[k].split(':'))[0].trim() === klevu_loginCustomerGroup &&
                3 === i.length &&
                Number(i[2].trim()) < Number(t.salePrice) &&
                (r = i[2].trim())
          ;(u = Number(r).formatMoneyForKlevu(
            d.decimalPlaces,
            '',
            d.thousandSeparator,
            d.decimalSeparator
          )),
            (c =
              '<span class="money">' +
              (c = klevu_commons.addCurrencyToPrice(
                // Price
                t.currency === 'RP ' || t.currency === 'HK$' || 'TWD' || '$'
                  ? u.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : u,
                // Currency symbol
                t.currency === 'THB'
                  ? '฿'
                  : t.currency === 'MOP'
                  ? 'MOP$'
                  : t.currency === 'RP '
                  ? ''
                  : t.currency === 'HK$'
                  ? '$'
                  : t.currency === 'TWD'
                  ? '$'
                  : t.currency,
                // Currency symbol position - True = after
                t.currency === 'THB'
                  ? true
                  : t.currency === '&euro;'
                  ? false
                  : o
              )) +
              '</span>'),
            'SLIM' === e
              ? (v = klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'BASIC' === e
              ? (v = klevu_layout.getPriceDivs('SALE', c, '', l))
              : 'LANDING' === e && (v = klevu_getPriceDivs('SALE', c, '', l))
        }
      if (
        (t.priceToDisplay.trim().length > 0 &&
          ('SLIM' === e
            ? (v += klevu_layout.getPriceDivs('SALE', t.priceToDisplay, '', l))
            : 'BASIC' === e
            ? (v += klevu_layout.getPriceDivs('SALE', t.priceToDisplay, '', l))
            : 'LANDING' === e &&
              (v += klevu_getPriceDivs('SALE', t.priceToDisplay, '', l))),
        t.startPrice.trim().length > 0 &&
          t.totalProductVariants &&
          '0' != t.totalProductVariants &&
          '0.00' !=
            (u = Number(t.startPrice).formatMoneyForKlevu(
              d.decimalPlaces,
              '',
              d.thousandSeparator,
              d.decimalSeparator
            )) &&
          ((showToLabel = !0),
          (c =
            '<span class="money">' +
            (c = klevu_commons.addCurrencyToPrice(u, t.currency, o)) +
            '</span>'),
          'SLIM' === e
            ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
            : 'BASIC' === e
            ? (v += klevu_layout.getPriceDivs('SALE', c, '', l))
            : 'LANDING' === e && (v += klevu_getPriceDivs('SALE', c, '', l))),
        -1 !== v.indexOf('class="klevu-saleprice-l2"'))
      ) {
        var p = 'class="klevu-saleprice-l2"'
        v = v.replace('class="klevu-saleprice-l2"', p)
        v = v.replace('.00', '')
      }
      if (-1 !== v.indexOf('class="kuSalePrice"')) {
        var y = 'class="kuSalePrice"'
        v = v.replace('class="kuSalePrice"', y)
        v = v.replace('.00', '')
      }
      return v
    },
    showLandingPageNoResultData: function (e) {
      var t,
        l = '',
        n = e.products || [],
        r = klevu_userOptions.noResultsOptions,
        a = !1,
        i = document.createElement('div')
      if (
        ((l += '<div class="kuNoResults-lp">'),
        (l += '<div class="kuNoResultsInner">'),
        (l +=
          '<div class="kuNoResults-lp-message" aria-live="assertive" role="status" tabindex="0">' +
          e.msgToShow +
          '</div>'),
        n && n.length > 0)
      ) {
        var s =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        ;(l += '<div class="kuNoResults-lp-relatedProducts">'),
          (l +=
            '<h3 class="kuNoResults-lp-title">' +
            ku_translations[s].youMayAlsoLike +
            '</h3>'),
          (l += '<ul class="kuNoResults-lp-relatedProduct-list">')
        for (var o = 0; o < n.length; o++)
          (l += '<li>'),
            (l += '<a href="' + n[o].url + '" class="kuRelatedProductbox-lp"'),
            klevu_commons.isMobileDevice()
              ? (l +=
                  ' onclick="return  klevu_analytics.trackClickedProduct(event, ' +
                  e.trackingParams[o] +
                  ');" target="_self" >')
              : (l +=
                  ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' +
                  e.trackingParams[o] +
                  ');"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                  e.trackingParams[o] +
                  ', klevu_analytics.trackClickedProduct);" ' +
                  e.additionalParams +
                  ' >'),
            ('undefined' == typeof klevu_truncateDescription ||
              ('undefined' != typeof klevu_truncateDescription &&
                klevu_truncateDescription)) &&
              n[o].desc.length > 33 &&
              (n[o].desc =
                n[o].desc.replace(/^(.{33}[^\s]*).*/, '$1') + ' ...'),
            (i.innerHTML = n[o].name),
            (t = i.textContent || i.innerText || ''),
            (l += '<div class="kuNoResultsImgWrap-lp">'),
            (l +=
              '<img src="' +
              n[o].imageUrl +
              '" onerror="this.onerror=null;this.src=\'' +
              klevu_userOptions.noImageUrl +
              '\';" alt="' +
              klevu_commons.escapeHtml(t) +
              '"/></div>'),
            (l += '<div class="kuProduct-desc">'),
            (l += '<div class="ku-name">' + n[o].name + '</div>'),
            (l += '<div class="ku-desc">' + n[o].desc + '</div>'),
            (l += '</div>'),
            void 0 !== n[o].storeBaseCurrency &&
              (n[o].currency = n[o].storeBaseCurrency),
            klevu_showPrices &&
              ((l += '<div class="kuPrice">'),
              klevu_userOptions.showOnlyOriginalAndSalePrices
                ? (l += klevu_commons.showOriginalAndSalePrices(
                    'LANDING',
                    n[o],
                    'kuSalePrice',
                    'kuSalePrice kuSpecialPrice'
                  ))
                : (l += klevu_commons.showProductPrices(
                    'LANDING',
                    n[o],
                    'kuSalePrice',
                    'kuSalePrice kuSpecialPrice'
                  )),
              (l += '</div>')),
            n[o].totalProductVariants &&
              '0' != n[o].totalProductVariants &&
              (l +=
                '<div class="kuVariants">+' +
                n[o].totalProductVariants +
                ' ' +
                klevu_uiLabels.variants +
                '</div>'),
            (l += '<div class="klevu-clear-left"></div>'),
            (l += '</a> </li>')
        ;(l += '</ul>'), (l += '</div>')
      }
      if (
        (e.banner &&
          e.banner.showOnLandingPage &&
          ((trackingParams =
            "{id: '" +
            e.banner.bannerRef +
            "',name: '" +
            e.banner.bannerName +
            "',image: '" +
            escape(e.banner.bannerImageUrl) +
            "',redirectUrl: '" +
            e.banner.redirectUrl +
            "'}"),
          klevu_commons.isMobileDevice()
            ? (trackingEvent = ' onclick=')
            : (trackingEvent =
                ' onclick="klevu_analytics.stopClickDefault( event );"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                trackingParams +
                ', klevu_analytics.trackClickedBannerAds);"  onmousedown='),
          (trackingEvent +=
            '"return klevu_analytics.trackClickedBannerAds(event, ' +
            trackingParams +
            ');" target="_blank">'),
          (l +=
            '<div class="kuNoResults-lp-banner"><a href="' +
            e.banner.redirectUrl +
            '" ' +
            trackingEvent +
            '<img src="' +
            e.banner.bannerImageUrl +
            '" alt="' +
            e.banner.bannerName +
            '"/></a></div>')),
        ((r && r.showPopularKeywords) ||
          klevu_userOptions.showPopularKeywordsForNoResult) &&
          (a = !0),
        'undefined' != typeof klevu_webstorePopularTerms &&
          klevu_webstorePopularTerms &&
          a)
      ) {
        var u = klevu_webstorePopularTerms,
          c = 1
        if (
          ((l += '<div class="kuNoResults-lp-pSearch">'),
          (l +=
            '<strong class="kuNoResults-lp-pSearch-title">' +
            klevu_uiLabels.popularSearches +
            ' </strong>'),
          u && u.length > 0)
        )
          for (o = 0; o < u.length; o++) {
            0 !== o && (l += ', ')
            try {
              l +=
                '<a href="' +
                e.landingPageUrl +
                encodeURIComponent(decodeURIComponent(u[o])) +
                '" target="_self">' +
                decodeURIComponent(u[o]) +
                '</a>'
            } catch (e) {
              continue
            }
            if (5 === c) break
            c++
          }
        l += '</div>'
      }
      return (l += '</div>'), (l += '</div>')
    },
    showResultsData: function (e) {
      var t = document,
        l = !0,
        n = t.getElementById('klevuSearchNoResults'),
        r = t.getElementById('klevuArrow'),
        a = t.getElementById('klevu-pt-rs-hover')
      if ((this.hideLoader(), 0 !== klevu_searchedTerm.length)) {
        a && (a.style.display = 'none'),
          n && (n.style.display = 'none'),
          klevu_showAdvancedAutosuggestionLayout
            ? this.showAdvancedAutoSuggestions(e.autoComplete, l, e.meta)
            : (this.showAutoSuggestions(e.autoComplete, e.meta),
              klevu_uc.showCmsContent(e.pages),
              this.showCategories(e.categories),
              ((e.autoComplete && e.autoComplete.length > 0) ||
                (e.categories && e.categories.length > 0) ||
                (e.pages && e.pages.length > 0)) &&
                (l = !1),
              klevu_uc.showProducts(e.meta, e.result, l, e.popularProducts),
              !l || e.result.length > 0
                ? klevu_commons.showBannerAdForGivenTerm(klevu_searchedTerm)
                : klevu_commons.showBannerAdForGivenTerm('')),
          (t.getElementById('klevuSearchingArea').style.cssText +=
            ';display : block !important;'),
          r && (r.style.display = 'none')
        var i =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        uc_helperFunctions.ifNoResults(
          e.result.length,
          'klevuResultsBlock-noResults'
        ),
          e.result.length <= 0
            ? document.getElementById('klevuProductHeading') &&
              ((document.getElementById('klevuProductHeading').style.display =
                'flex'),
              document.querySelector('.ku-noProducts') ||
                document
                  .getElementById('klevuProductHeading')
                  .insertAdjacentHTML(
                    'afterend',
                    '<div class="ku-noProducts">' +
                      ku_translations[i].noProducts +
                      '</div>'
                  ))
            : document.querySelector('.ku-noProducts') &&
              document.querySelector('.ku-noProducts').remove(),
          uc_helperFunctions.ifNoResults(
            e.pages.length,
            'klevuCmsContentArea-noResults'
          ),
          e.pages.length <= 0 && document.getElementById('klevuCmsContentArea')
            ? ((document.getElementById('klevuCmsContentArea').style.display =
                'block'),
              document.querySelector(
                '#klevuCmsContentArea .klevuSuggestionHeading'
              ) &&
                (document.querySelector('.ku-noCMS') ||
                  document
                    .querySelector(
                      '#klevuCmsContentArea .klevuSuggestionHeading'
                    )
                    .insertAdjacentHTML(
                      'afterend',
                      '<div class="ku-noCMS">' +
                        ku_translations[i].noCMS +
                        '</div>'
                    )))
            : document.querySelector('.ku-noCMS') &&
              document.querySelector('.ku-noCMS').remove(),
          uc_helperFunctions.ifNoResults(
            e.autoComplete.length,
            'klevuAutoCompleteArea-noResults'
          ),
          uc_helperFunctions.ifNoResults(
            e.categories.length,
            'klevuCategoryArea-noResults'
          )
      }
    },
    showProducts: function (e, t, l, n) {
      var r,
        a,
        i,
        s = document,
        o = '',
        u = klevu_userOptions.recordsPerPage,
        c = 0,
        d = s.getElementById('productsList'),
        v = '',
        k = '',
        m = '',
        g = '',
        p = '',
        y = '',
        h = '',
        _ = '',
        f = '',
        P = '',
        S = '',
        b = '',
        F = '',
        C = '',
        w = '',
        E = '',
        L = '',
        T = s.getElementById('klevuProductHeading'),
        B = '',
        I = '',
        A = 0,
        N = s.createElement('div'),
        x = klevu_commons.getRedirectUrlForSearchedTerm(klevu_searchedTerm)
      if (
        ('undefined' != typeof klevu_storeLandingPageUrl &&
          (B = klevu_storeLandingPageUrl),
        (B =
          'undefined' != typeof klevu_searchQueryParam && klevu_searchQueryParam
            ? klevu_commons.updateUrlParameter(B, klevu_searchQueryParam, '')
            : klevu_commons.updateUrlParameter(B, 'q', '')),
        null !== x ? (B = x) : (B += encodeURIComponent(klevu_searchedTerm)),
        t.length > 0)
      ) {
        var R =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        for (
          T.innerHTML =
            '<span class="klevuHeadingText">' +
            ku_translations[R].ProductResults +
            '</span>',
            I =
              '<a href="' +
              B +
              '" target="_parent">' +
              ku_translations[R].viewAll +
              '</a>',
            klevu_layout.loaderPlaced
              ? (T.innerHTML += I)
              : (T.innerHTML +=
                  '<span class="klevuLoader" id="klevu-loader-2">' +
                  I +
                  '</span>'),
            T.style.display = 'flex',
            o = '<ul>',
            c = 0;
          c < t.length && c < u;
          c++
        ) {
          for (i in ((k = t[c].name || ''),
          (v =
            t[c].shortDescription ||
            t[c].shortDesc ||
            t[c].desc ||
            t[c].metaDesc ||
            ''),
          (m = t[c].brand || ''),
          (g = t[c].id || ''),
          (p = t[c].salePrice || ''),
          (h = t[c].price || ''),
          (_ = t[c].imageUrl || t[c].image || ''),
          (f = t[c].currency || ''),
          (S = t[c].displayPrice || ''),
          (b = t[c].totalVariants || ''),
          (F = t[c].url || ''),
          (w = t[c].startPrice || ''),
          (E = t[c].toPrice || ''),
          (L = t[c].sku || ''),
          (y = t[c].groupPrices || ''),
          (P = t[c].rating || ''),
          (C = t[c].discount || ''),
          (a = null),
          (i = null),
          (A = 1 + c),
          (N.innerHTML = v),
          (v = N.textContent || N.innerText || '').length > 33 &&
            (v = v.replace(/^(.{33}[^\s]*).*/, '$1') + ' ...'),
          (r = v.lastIndexOf('<b')) > v.lastIndexOf('</b>') &&
            (v = v.substring(0, r - 1)),
          (a = {
            productCode: g,
            productImage: _,
            productBrand: m,
            productUrl: F,
            productName: k.split('|')[0].replace('·', '<br />'),
            productDescription: v,
            productPrice: h,
            salePrice: p,
            currency: f,
            priceToDisplay: S,
            startPrice: w,
            toPrice: E,
            totalProductVariants: b,
            productSku: L,
            groupPrices: y,
            rating: P,
            discount: C,
            productPosition: A
          }),
          t[c]))
            t[c].hasOwnProperty(i) && (a[i] = t[c][i])
          ;(o += klevu_layout.displayProductdata(a)), (N.innerHTML = '')
        }
        ;(o += '</ul>'), (d.innerHTML = o)
      } else if (((T.style.display = 'none'), (d.innerHTML = ''), l)) {
        var O = s.getElementById('klevuSearchNoResults')
        ;(O.innerHTML = klevu_layout.displayNoResultData(
          klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, n)
        )),
          (O.style.display = 'block')
      }
      d.style.display = 'block'
    },
    showCmsContent: function (e) {
      var t = document.getElementById('klevuCmsContentArea'),
        l = 2,
        n = '',
        r = '',
        a = 0
      if (
        ('undefined' != typeof klevu_maxPagesToShow &&
          klevu_maxPagesToShow &&
          (l = klevu_maxPagesToShow),
        'undefined' != typeof klevu_storeLandingPageUrl &&
          (r = klevu_storeLandingPageUrl),
        (r =
          'undefined' != typeof klevu_searchQueryParam && klevu_searchQueryParam
            ? klevu_commons.updateUrlParameter(r, klevu_searchQueryParam, '')
            : klevu_commons.updateUrlParameter(r, 'q', '')),
        (r += encodeURIComponent(klevu_searchedTerm) + '&goToCMS=true'),
        e && e.length > 0)
      ) {
        var i =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        for (
          n =
            '<div class="klevuSuggestionHeading"><span class="klevuHeadingText">' +
            ku_translations[i].articles +
            '</span><a href="' +
            r +
            '">' +
            ku_translations[i].viewAll +
            '</a>',
            klevu_layout.loaderPlaced ||
              ((n += '<span class="klevuLoader" id="klevu-loader-2"></span>'),
              (klevu_layout.loaderPlaced = !0)),
            n += '</div>',
            n += '<ul>',
            a = 0;
          a < e.length && a < l;
          a++
        ) {
          var s = e[a].imageUrl
            ? e[a].imageUrl
            : e[a].image
            ? e[a].image
            : klevu_userOptions.noImageUrl
          n += '<li>\n<a href="'
            .concat(
              e[a].url,
              '" target="_self" class="ku-cms-link">\n<div class="ku-img-wrap">\n<img src="'
            )
            .concat(s, '" alt="')
            .concat(e[a].name, '"/>\n</div>\n<div class="ku-cms-name">\n')
            .concat(e[a].name, '\n</div>\n</a>\n</li>')
        }
        ;(n += '</ul>'), (t.innerHTML = n), (t.style.display = 'block')
      } else t.style.display = 'none'
    },
    addAutocompleteLayoutToPage: function (e) {
      var t, l, n, r, a, i, s, o, u, c
      if (
        (klevu_fluidLayoutEnabled
          ? ((r = this.addElementToParent(e, 'div', {
              class: 'klevu-fluid',
              role: 'region',
              'aria-label': 'Klevu Search Container'
            })),
            'undefined' != typeof klevu_bigCommerceStore &&
              klevu_bigCommerceStore &&
              r.setAttribute('data-prevent-quick-search-close', ''))
          : (r = e),
        (loaderContainerDiv = this.addElementToParent(r, 'div', {
          class: 'klevu-searching-area-l2',
          id: 'loaderContainer',
          style: 'display:none;'
        })),
        this.addLoaderDiv(loaderContainerDiv),
        this.addElementToParent(r, 'div', {
          class: 'klevu-arrow',
          id: 'klevuArrow',
          style: 'display:none;'
        }),
        (t = this.addElementToParent(r, 'div', {
          class: 'klevu-searching-area-l2',
          id: 'klevuSearchingArea',
          style: 'display:none;',
          tabindex: '-1'
        })),
        klevu_showPopularSearches ||
          klevu_showRecentSerches ||
          klevu_userOptions.showRecentlyViewedItems ||
          klevu_userOptions.showTrendingProducts)
      ) {
        ;(a = document.createElement('div')).setAttribute(
          'class',
          'klevu-pt-rs-hover'
        ),
          a.setAttribute('id', 'klevu-pt-rs-hover'),
          a.setAttribute('tabindex', '-1'),
          (a.style.display = 'none'),
          klevu_fluidLayoutEnabled
            ? ((i = document.createElement('div')).setAttribute(
                'class',
                'klevu-fluid'
              ),
              i.setAttribute('role', 'region'),
              i.setAttribute('aria-label', 'Klevu Personalisation Container'),
              i.appendChild(a),
              e.appendChild(i))
            : e.appendChild(a)
        var d = !1
        klevu_showPopularSearches && (d = this.addPopularSearchesDiv(a)),
          klevu_showRecentSerches && (d = this.addRecentSearchesDiv(a)),
          d || (a.style.display = 'none')
      }
      var v = this.addElementToParent(t, 'div', { class: 'ku-searchWrap' })
      if (
        (this.addElementToParent(v, 'div', {
          class: 'klevuNoResults klevuNoResults-new',
          id: 'klevuSearchNoResults',
          style: 'display:none;'
        }),
        screenWidthCheck())
      ) {
        ;(s = this.addElementToParent(v, 'div', {
          class: 'klevuSuggestionsBlock',
          id: 'klevuSuggestionsBlock'
        })),
          this.addElementToParent(s, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuAutoCompleteArea',
            style: 'display:none;'
          }),
          (o = this.addElementToParent(v, 'div', {
            class: 'klevuResultsBlock',
            id: 'klevuResultsBlock'
          })),
          this.addElementToParent(o, 'div', {
            class: 'klevuSuggestionHeading',
            id: 'klevuProductHeading',
            style: 'display:none;'
          }),
          this.addElementToParent(o, 'div', {
            class: 'klevuSearchResults-l2',
            id: 'productsList',
            style: 'display:none;'
          }),
          (l = this.addElementToParent(v, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuCmsContentArea',
            style: 'display:none;'
          }))
        var k =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        ;((n = this.addElementToParent(l, 'div', {
          class: 'klevuSuggestionHeading',
          style: 'display:none;'
        })).innerHTML =
          '<span class="klevuHeadingText">' +
          ku_translations[k].articles +
          '</span>'),
          'undefined' != typeof klevu_showBannerAds &&
            klevu_showBannerAds &&
            this.addElementToParent(v, 'div', {
              class: 'klevu-banner-ad',
              id: 'klevuBannerAdTop',
              style: 'padding:0px;'
            }),
          this.addElementToParent(v, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuCategoryArea',
            style: 'display:none;'
          })
      } else {
        ;(l = this.addElementToParent(v, 'div', {
          class: 'klevuAutoSuggestion-l2',
          id: 'klevuCmsContentArea',
          style: 'display:none;'
        })),
          (n = this.addElementToParent(l, 'div', {
            class: 'klevuSuggestionHeading',
            style: 'display:none;'
          }))
        k =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        ;(n.innerHTML =
          '<span class="klevuHeadingText">' +
          ku_translations[k].articles +
          '</span>'),
          (o = this.addElementToParent(v, 'div', {
            class: 'klevuResultsBlock',
            id: 'klevuResultsBlock'
          })),
          this.addElementToParent(o, 'div', {
            class: 'klevuSuggestionHeading',
            id: 'klevuProductHeading',
            style: 'display:none;'
          }),
          this.addElementToParent(o, 'div', {
            class: 'klevuSearchResults-l2',
            id: 'productsList',
            style: 'display:none;'
          }),
          'undefined' != typeof klevu_showBannerAds &&
            klevu_showBannerAds &&
            this.addElementToParent(v, 'div', {
              class: 'klevu-banner-ad',
              id: 'klevuBannerAdTop',
              style: 'padding:0px;'
            })
        var m = this.addElementToParent(v, 'div', {
          class: 'suggestionsWrapperBlock'
        })
        ;(s = this.addElementToParent(m, 'div', {
          class: 'klevuSuggestionsBlock',
          id: 'klevuSuggestionsBlock'
        })),
          this.addElementToParent(s, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuAutoCompleteArea',
            style: 'display:none;'
          }),
          this.addElementToParent(m, 'div', {
            class: 'klevuAutoSuggestion-l2',
            id: 'klevuCategoryArea',
            style: 'display:none;'
          })
      }
      ;(this.addElementToParent(v, 'div', {
        class: 'ku-close-search'
      }).innerHTML =
        '<div onclick="uc_helperFunctions.closeQuickSearch()"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20"><path d="M11.59 10L19 2.59 17.41 1 10 8.41 2.59 1 1 2.59 8.41 10 1 17.41 2.59 19 10 11.59 17.41 19 19 17.41z"/></svg></div>'),
        'undefined' != typeof klevu_showBannerAds &&
          klevu_showBannerAds &&
          this.addElementToParent(v, 'div', {
            class: 'klevu-banner-ad',
            id: 'klevuBannerAdBottom',
            style: 'padding:0px;'
          }),
        klevu_logoFreeSearch || this.addPoweredByDiv(v),
        klevu_fluidLayoutEnabled ? ((c = r), (u = i)) : ((c = v), (u = a)),
        this.addElementToParent(c, 'div', {
          onkeydown: 'klevu_commons.setupNextTabForLastChild();',
          tabindex: '0'
        }),
        (klevu_showPopularSearches ||
          klevu_showRecentSerches ||
          klevu_userOptions.showRecentlyViewedItems ||
          klevu_userOptions.showTrendingProducts) &&
          this.addElementToParent(u, 'div', {
            onkeydown: 'klevu_commons.setupNextTabForLastChild();',
            tabindex: '0'
          })
    },
    landingFilters: {
      loadingFiltersFor: 'search-query',
      lastSelectedFilters: '',
      showFilters: function (e) {
        var t,
          l,
          n = document.getElementById('kuFilters'),
          r = 0,
          a = 0,
          i = new Array(),
          s = '',
          o = klevu_commons.isMobileDevice()
            ? document.getElementById('kuFilterRefineMobile')
            : document.getElementById('klevuNarrowByLabel')
        if (
          ((klevuLandingFilterTxt = ''),
          (n.innerHTML = ''),
          'undefined' != typeof klevu_multiSelectFilters &&
            klevu_multiSelectFilters &&
            (s = ' kuMulticheck'),
          e && e.length > 0)
        ) {
          for (n.className = 'kuFilters' + s, t = 0, l = e.length; t < l; t++)
            ('Price Range' !== e[t].key || klevu_showPrices) &&
              ((i[r] = klevu_landingFilters.displayFiltersData(e[t])), r++)
          for (
            n.innerHTML = klevuLandingFilterTxt,
              void 0 !== o &&
                o &&
                (0 === klevuLandingFilterTxt.trim().length
                  ? (o.style.display = 'none')
                  : (o.style.display = 'block')),
              t = 0,
              l = i.length;
            t < l;
            t++
          )
            i[t] &&
              '' != i[t].trim() &&
              (document.getElementById(i[t]).style.height = 'auto')
          for (r = 0, a = 0, l = e.length; a < l; a++) {
            var u = e[a].key.replace(' ', '_'),
              c = e[a].options
            for (t = 0; t < c.length; t++) {
              var d = t + u + '~text'
              'true' === c[t].isSelected.trim() &&
                (klevu_landingFilters.showSelectedFilter(
                  d,
                  c[t].name,
                  r,
                  e[a].label
                ),
                r++)
            }
          }
          'undefined' != typeof klevu_showPriceSlider &&
            klevu_showPriceSlider &&
            -1 !==
              klevu_userOptions.selectedLandingFilters.indexOf('klevu_price') &&
            (klevu_landingFilters.showSelectedFilter(
              null,
              klevu_userOptions.selectedLandingFilters.match(
                /klevu_price:[0-9.\- ]*;*/
              )[0],
              r,
              null,
              'Price-Range'
            ),
            r++),
            0 === r && klevu_landingFilters.showSelectedFilter(null, null, -1),
            (n.style.display = 'none'),
            n.offsetHeight,
            (n.style.display = 'block'),
            document.getElementById('kuFilterRefineMobile') &&
              klevu_commons.isMobileDevice() &&
              (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile ||
                screen.width < 768) &&
              (klevu_landingFilters.lastSelectedFilters ===
              klevu_userOptions.selectedLandingFilters
                ? klevu_landingFilters.showFiltersOnMobile(!1)
                : klevu_landingFilters.showFiltersOnMobile(!(0 === r)),
              (klevu_landingFilters.lastSelectedFilters =
                klevu_userOptions.selectedLandingFilters))
        } else n.className = 'kuFilters disableKuFilter' + s
      },
      displayFiltersData: function (e) {
        if (e) {
          var t,
            l,
            n = klevu_translateFilterLabel(e.label),
            r = !1,
            a = '',
            i = e.options,
            s = e.key.replace(' ', '_'),
            o = !1,
            u = 'kuHover'
          ;(klevu_userOptions.truncateFilterLabel = !1),
            'price range' === e.label.toLowerCase() && (r = !0),
            'MSRP' === e.label && !0,
            'inStock' === e.key && !0,
            klevu_commons.isMobileDevice() && (u = ''),
            i.length > 6
              ? (a +=
                  '<div class="kuFilterBox ' +
                  u +
                  '" id="kuFilterBox-' +
                  s +
                  '">')
              : (a +=
                  '<div class="kuFilterBox ' +
                  u +
                  '" style="height:auto;" id="kuFilterBox-' +
                  s +
                  '">')
          var c = []
          i.forEach(function (e) {
            'true' === e.isSelected && c.push(e.name)
          }),
            c.length > 0 && screenWidthCheck()
              ? (a += '<div class="kuFilterHead kuCollapse" id="kuFilterHead-'
                  .concat(
                    s,
                    '" \n            onclick="klevu_landingFilters.collapseExpand(\'kuFilterHead-'
                  )
                  .concat(s, "', 'kuFilterNames-")
                  .concat(s, "', 'kuShowOpt-")
                  .concat(s, "', 'kuHideOpt-")
                  .concat(s, "', 'kuFilterBox-")
                  .concat(s, '\' );">\n            <span>')
                  .concat(n, '</span> <span class="ku-selectedFacets">')
                  .concat(
                    c.join(', '),
                    '</span>\n            </div>\n            <div class="kuFilterNames" id="kuFilterNames-'
                  )
                  .concat(s, '"><ul>'))
              : (a += '<div class="kuFilterHead kuCollapse" id="kuFilterHead-'
                  .concat(
                    s,
                    '" \n            onclick="klevu_landingFilters.collapseExpand(\'kuFilterHead-'
                  )
                  .concat(s, "', 'kuFilterNames-")
                  .concat(s, "', 'kuShowOpt-")
                  .concat(s, "', 'kuHideOpt-")
                  .concat(s, "', 'kuFilterBox-")
                  .concat(s, '\' );">\n            ')
                  .concat(
                    n,
                    '\n            </div>\n            <div class="kuFilterNames" id="kuFilterNames-'
                  )
                  .concat(s, '"><ul>'))
          for (var d = 0, v = i.length; d < v; d++) {
            var k = i[d].isSelected,
              m = d + s + '~text',
              g = '',
              p = 'kuFilterTotal',
              y = i[d].count,
              h = "klevu_landingFilters.sendQuery('" + m + "', true );"
            if (
              ('true' === k.trim() &&
                ((g = 'kuSelected'),
                (p = 'kuFilterCancel'),
                'undefined' != typeof klevu_multiSelectFilters &&
                klevu_multiSelectFilters
                  ? ((y = i[d].count), (o = !0))
                  : (y = 'X'),
                (h = "klevu_landingFilters.cancelFilter('" + m + "'); ")),
              (t = i[d].name),
              r)
            ) {
              t = klevu_commons.replaceCurrencyWithItsSymbol(
                t,
                klevu_storeLandingCurrency
              )
              try {
                var _ = t.split('-').map(function (e) {
                  return e.trunc(), '<span class="money">'.concat(e, '</span>')
                })
                t = _.join(' - ')
              } catch (e) {
                console.log(e)
              }
              ;(l = t), (t = '')
            } else l = klevu_userOptions.truncateFilterLabel ? t.trunc(18) : t
            a +=
              '<li id="' +
              d +
              s +
              '" class="' +
              g +
              '"><a href="javascript:void(0);" onclick="' +
              h +
              '" title="' +
              t +
              '" target="_self"><span class="kuFilterLabel">' +
              l +
              '</span><span class="' +
              p +
              '">(' +
              y +
              ')</span></a></li><input type="hidden" id="' +
              m +
              '" value="' +
              klevu_commons.escapeHtml(i[d].value) +
              '"/>'
          }
          if (
            ((a +=
              '<button class="ku-clear-facet">Clear</button></ul></div></div>'),
            i.length > 6 &&
              (o
                ? (a = a.replace(
                    '<div class="kuFilterBox ' +
                      u +
                      '" id="kuFilterBox-' +
                      s +
                      '">',
                    '<div class="kuFilterBox ' +
                      u +
                      '" style="height:auto;" id="kuFilterBox-' +
                      s +
                      '">'
                  ))
                : (a +=
                    '<div class="kuShowOpt" id="kuShowOpt-' +
                    s +
                    '" style="display:block;text-align:center;"><a href="javascript:klevu_landingFilters.showAll( \'kuFilterBox-' +
                    s +
                    '\' );" title="' +
                    klevu_uiLabels.showMore +
                    '" target="_self"><img src="' +
                    klevu_userOptions.viewMoreImageUrl +
                    '" alt="' +
                    klevu_uiLabels.showMore +
                    '"/></a></div><div class="kuHideOpt" id="kuHideOpt-' +
                    s +
                    '" style="display:none;text-align:center;"><a href="javascript:void(0);" onclick="klevu_landingFilters.hideAll(\'kuFilterBox-' +
                    s +
                    '\');" title="' +
                    klevu_uiLabels.showLess +
                    '" target="_self"><img src="' +
                    klevu_userOptions.viewLessImageUrl +
                    '" alt="' +
                    klevu_uiLabels.showLess +
                    '"/></a></div>')),
            (klevuLandingFilterTxt += a),
            i.length > 0 && i.length < 6)
          )
            return 'kuFilterBox-' + s
        }
      },
      displayPricingSlider: function () {
        var e = klevu_translateFilterLabel('PRICE RANGE').toUpperCase(),
          t = '',
          l = 'Price-Range',
          n = 'klevuPriceRangeSlider'
        return (
          (t +=
            (1).length > 6
              ? '<div class="kuFilterBox" id="kuFilterBox-' + l + '">'
              : '<div class="kuFilterBox" style="height:auto;" id="kuFilterBox-' +
                l +
                '">'),
          (t +=
            '<div class="kuFilterHead kuCollapse" id="kuFilterHead-' +
            l +
            '" onclick="klevu_landingFilters.collapseExpand( \'kuFilterHead-' +
            l +
            "', 'kuFilterNames-" +
            l +
            "', 'kuShowOpt-" +
            l +
            "', 'kuHideOpt-" +
            l +
            "', 'kuFilterBox-" +
            l +
            '\' );">' +
            e +
            '</div><div class="kuFilterNames" id="kuFilterNames-' +
            l +
            '">'),
          'undefined' != typeof klevu_current_version &&
            klevu_current_version &&
            ((klevuPluginVersion = klevu_commons.compareVersionNumbers(
              klevu_current_version,
              '2.0.2'
            )),
            !isNaN(klevuPluginVersion) &&
              klevuPluginVersion >= 0 &&
              (n = 'kuPriceRangeSlider'),
            (klevuPluginVersion = klevu_commons.compareVersionNumbers(
              klevu_current_version,
              '2.0.0'
            )),
            !isNaN(klevuPluginVersion) &&
              klevuPluginVersion < 0 &&
              ((klevuPluginVersion = klevu_commons.compareVersionNumbers(
                klevu_current_version,
                '1.2.5'
              )),
              !isNaN(klevuPluginVersion) &&
                klevuPluginVersion >= 0 &&
                (n = 'kuPriceRangeSlider'))),
          'undefined' != typeof klevu_shopifyStore &&
            klevu_shopifyStore &&
            (n = 'kuPriceRangeSlider'),
          (t += '<div class="' + n + '"><div id="ku-price-range"></div>'),
          (t +=
            '<div > <span id="ku-from-price"></span>&nbsp; <span id="ku-to-price"></span></div></div>'),
          (t += '</div></div>')
        )
      },
      sendQuery: function (e, t) {
        var l,
          n,
          r = document,
          a = '',
          i = '',
          s = (r.getElementById('kuFilters'), '')
        t && (r.getElementById(e.split('~')[0]).className = 'kuSelected'),
          'undefined' != typeof klevu_userFilterResults &&
            (i = klevu_userFilterResults),
          (l = '')
        for (
          var o = 0,
            u = (n = getElementsByClassName('kuSelected', 'li')).length;
          o < u;
          o++
        )
          (a = klevu_commons.unescapeHtml(
            r.getElementById(n[o].id + '~text').value
          )),
            -1 === i.indexOf(a) &&
              ('' === l.trim() ? (l += a) : (l += ';;' + a))
        return (
          'undefined' != typeof klevu_showPriceSlider &&
            klevu_showPriceSlider &&
            -1 !==
              klevu_userOptions.selectedLandingFilters.indexOf('klevu_price') &&
            (s =
              ';;' +
              klevu_userOptions.selectedLandingFilters.match(
                /klevu_price:[0-9.\- ]*;*/
              )[0]),
          (klevu_userOptions.selectedLandingFilters = l + s),
          klevu_addSelectedFiltersToUrl &&
            klevu_commons.addSelectedFiltersToPageUrl(
              klevu_userOptions.selectedLandingFilters,
              klevu_productFilterParam
            ),
          (klevu_pagination.landingStartPosition = 0),
          ('undefined' != typeof klevu_multiSelectFilters &&
            klevu_multiSelectFilters) ||
            (document.body.scrollTop = document.documentElement.scrollTop = 0),
          r.getElementById('kuProductContent') &&
            (r.getElementById('kuProductContent').style.opacity = '0.3'),
          (klevu_landingFilters.loadingFiltersFor = 'filter-selection'),
          klevu_search.fetchResults(
            r.getElementById('searchedKeyword').value,
            'klp'
          ),
          !1
        )
      },
      showAll: function (e, t) {
        var l = document,
          n = l.getElementById(e),
          r = e.substring(e.indexOf('-') + 1, e.length)
        ;(n.style.height = 'auto'),
          (n.style.overflow = 'visible'),
          (l.getElementById('kuShowOpt-' + r).style.display = 'none'),
          (l.getElementById('kuHideOpt-' + r).style.display = 'block')
      },
      hideAll: function (e) {
        var t = document,
          l = t.getElementById(e),
          n = e.substring(e.indexOf('-') + 1, e.length)
        ;(l.style.height = ''),
          (l.style.overflow = 'hidden'),
          (t.getElementById('kuShowOpt-' + n).style.display = 'block'),
          (t.getElementById('kuHideOpt-' + n).style.display = 'none')
      },
      showSelectedFilter: function (e, t, l, n, r) {
        var a = document,
          i = a.getElementById('ku-search-filter-tags'),
          s = (a.getElementById('kuClearAllFilters'), '')
        if (i) {
          if (-1 === l) return void (i.innerHTML = '')
          0 === l && (i.innerHTML = ''),
            n && (s = n + ' : '),
            void 0 !== _typeof(r) && 'Price-Range' === r
              ? a.getElementById('kuPriceRangeTag') ||
                ((t = t.split(':')[1]),
                (s =
                  klevu_translateFilterLabel('PRICE RANGE').toUpperCase() +
                  ' : '),
                (i.innerHTML +=
                  '<span class="ku-search-filter-tag" id="kuPriceRangeTag"> ' +
                  s +
                  t +
                  ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelPriceSliderFilter(); " target="_self" href="#">x</a></span> '))
              : (i.innerHTML +=
                  '<a class="ku-search-filter-tag" onclick="klevu_landingFilters.cancelFilter(\'' +
                  e +
                  '\'); " target="_self" href="#"> ' +
                  t +
                  ' <span class="ku-search-filter-remove">x</span></a> '),
            a.getElementById('kuClearAllFilters') &&
              a
                .getElementById('kuClearAllFilters')
                .parentNode.removeChild(a.getElementById('kuClearAllFilters')),
            (i.innerHTML +=
              '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingFilters.clearAllFilters(); " onkeydown="klevu_eventHandler.handleElementKeydownEvent(event, null, klevu_landingFilters.clearAllFilters);" tabindex="0"><a> ' +
              klevu_uiLabels.clearAll +
              '</a></span>')
        }
      },
      cancelFilter: function (e) {
        ;(document.getElementById(e.split('~')[0]).className = ''),
          klevu_landingFilters.sendQuery(e, !1)
      },
      cancelPriceSliderFilter: function () {
        ;(klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(
          /klevu_price:[0-9.\- ]*;*/,
          ''
        )),
          klevu_landingFilters.sendQuery('', !1)
      },
      clearAllFilters: function () {
        for (
          var e = getElementsByClassName('kuSelected', 'li'),
            t = 0,
            l = e.length;
          t < l;
          t++
        )
          e[t].className = ''
        document.getElementById('kuPriceRangeTag') &&
          (klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(
            /klevu_price:[0-9.\- ]*;*/,
            ''
          )),
          klevu_landingFilters.sendQuery('', !1)
      },
      collapseExpand: function (e, t, l, n, r) {
        var a = document,
          i = a.getElementById(e),
          s = a.getElementById(t),
          o = a.getElementById(l),
          u = a.getElementById(n),
          c = a.getElementById(r)
        ;-1 !== i.className.indexOf('kuCollapse')
          ? ((i.className = 'kuFilterHead kuExpand'),
            (s.style.display = 'none'),
            o && (o.style.display = 'none'),
            u && (u.style.display = 'none'),
            (klevu_landingFilters.filterHeight = c.style.height),
            (c.style.height = '50px'))
          : -1 !== i.className.indexOf('kuExpand') &&
            ((i.className = 'kuFilterHead kuCollapse'),
            (s.style.display = 'block'),
            o && (o.style.display = 'block'),
            u && (u.style.display = 'none'),
            o && u
              ? klevu_landingFilters.hideAll(r)
              : (c.style.height = 'auto'))
      },
      showFiltersOnMobile: function (e) {
        var t = document,
          l = t.getElementById('kuFilters'),
          n = t.getElementById('kuFilterRefineMobile')
        if (((e = void 0 === e || e), -1 !== n.className.indexOf('kuCollapse')))
          e
            ? ((n.className = 'kuFilterRefineMobile kuExpand'),
              (l.style.cssText += ';display : none !important;'))
            : (l.style.cssText += ';display : block !important;')
        else if (-1 !== n.className.indexOf('kuExpand')) {
          e
            ? ((n.className = 'kuFilterRefineMobile kuCollapse'),
              (l.style.cssText += ';display : block !important;'))
            : (l.style.cssText += ';display : none !important;')
          for (
            var r = getElementsByClassName('kuFilterHead', 'div'),
              a = 0,
              i = r.length;
            a < i;
            a++
          )
            -1 !== r[a].className.indexOf('kuCollapse') && r[a].click()
        }
      }
    },
    showLandingPageCmsData: function (e) {
      var t,
        l = '',
        n = '',
        r = document.getElementById('searchedKeyword').value
      ;(n = klevu_userOptions.openProductClicksInNewWindow
        ? ' target="_blank"'
        : ' onclick="klevu_analytics.stopClickDefault( event );"'),
        (t =
          "{data: {code: '" +
          escape(e.contentCode) +
          "',url: '" +
          escape(e.contentUrl) +
          "',name: '" +
          escape(e.contentTitle) +
          "',position: " +
          e.contentPosition +
          "},apiKey: '" +
          klevu_cmsApiKey +
          "',keywordsLP: '" +
          escape(r) +
          "',forCms: true}")
      var a = e.imageUrl ? e.imageUrl : e.image ? e.image : ''
      return (
        (l += '<li>'),
        (l +=
          '<a class="ku-Card" href="' + e.contentUrl + '" target="_blank" '),
        klevu_commons.isMobileDevice()
          ? (l +=
              ' onclick="return klevu_analytics.trackClickedProduct(event, ' +
              t +
              ');" >')
          : (l +=
              ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' +
              t +
              ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
              t +
              ', klevu_analytics.trackClickedProduct);" ' +
              n +
              '>'),
        (l += '<div class="ku-Card_Content">'),
        (l += '<h3 class="ku-Card_Title fz-20_28">' + e.contentTitle),
        (l += '</h3>'),
        (l +=
          '<div class="ku-Card_Text fz-14_24">' +
          e.contentDescription +
          '</div>'),
        (l += '</div>'),
        (l += '</a>'),
        (l += '</li>')
      )
    },
    displayNoResultData: function (e) {
      e.msgToShow ||
        (e = klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, e))
      var t,
        l = '',
        n = e.products || [],
        r = klevu_userOptions.noResultsOptions,
        a = !1,
        i = document.createElement('div')
      if (
        ((l += '<div class="klevuSearchNoResults-Inner">'),
        (l +=
          '<div class="klevuNoResults-message" aria-live="assertive" role="status" tabindex="0">' +
          e.msgToShow +
          '</div>'),
        n && n.length > 0)
      ) {
        var s =
          'undefined' != typeof klevu_lang && '' !== klevu_lang
            ? klevu_lang
            : 'en'
        ;(l += '<div class="klevuSearchNoResultsBlock">'),
          (l += '<div class="klevuSearchNoResults-l2">'),
          (l +=
            '<div class="klevuSearchNoResultsHeading">' +
            ku_translations[s].youMayAlsoLike +
            '</div>'),
          (l += '<ul>')
        for (var o = 0; o < n.length; o++) l += '<li>'
        l += `<a href="${n[o].url}" class="prd-Card prd-Card-grid">`
        l += `<div class="prd-Card_ImageContainer">`
        const productImage =
          n[o].imageUrl.indexOf('_400x800.jpg') >= 0
            ? n[o].imageUrl.replace('_400x800.jpg', '_900x.jpg')
            : n[o].imageUrl
        l += `<div class="prd-Card_Image"><img src="${productImage}" class="prd-Card_KlevuImage" onerror="this.onerror=null;this.src='${klevu_userOptions.noImageUrl}';" alt="${n[o].name}"/></div>`
        l += '</div>'
        l += '<div class="prd-Card_Content">'
        l += `<h3 class="prd-Card_Title fz-1525">${n[o].name
          .split('|')[0]
          .replace('·', '<br />')}</h3>`
        l += '<div class="prd-Card_Price fz-1525">'
        if (klevu_showPrices) {
          l += klevu_landingProductElements
            .showPrices(n[o], 'prd-Product_Price')
            .replace('.00', '')
        }
        l += '</div>'
        l += '</div>'
        l += '</a>'
        l += '</li>'
        ;(l += '</ul>'), (l += '</div>'), (l += '</div>')
      }
      if (
        (e.banner &&
          e.banner.showOnQuickSearch &&
          ((trackingParams =
            "{id: '" +
            e.banner.bannerRef +
            "',name: '" +
            e.banner.bannerName +
            "',image: '" +
            escape(e.banner.bannerImageUrl) +
            "',redirectUrl: '" +
            e.banner.redirectUrl +
            "'}"),
          klevu_commons.isMobileDevice()
            ? (trackingEvent = ' onclick=')
            : (trackingEvent =
                ' onclick="klevu_analytics.stopClickDefault( event );"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                trackingParams +
                ', klevu_analytics.trackClickedBannerAds);"  onmousedown='),
          (trackingEvent +=
            '"return klevu_analytics.trackClickedBannerAds(event, ' +
            trackingParams +
            ');" target="_blank">'),
          (l +=
            '<div class="kuNoResults-banner"><a href="' +
            e.banner.redirectUrl +
            '" ' +
            trackingEvent +
            '<img src="' +
            e.banner.bannerImageUrl +
            '" alt="' +
            e.banner.bannerName +
            '"/></a></div>')),
        ((r && r.showPopularKeywords) ||
          klevu_userOptions.showPopularKeywordsForNoResult) &&
          (a = !0),
        'undefined' != typeof klevu_webstorePopularTerms &&
          klevu_webstorePopularTerms &&
          a)
      ) {
        var u = klevu_webstorePopularTerms,
          c = 1
        if (
          ((l += '<div class="klevuNoResults-pSearch">'),
          (l +=
            '<strong class="klevuNoResults-pSearchTitle">' +
            klevu_uiLabels.popularSearches +
            ' </strong>'),
          u && u.length > 0)
        )
          for (o = 0; o < u.length; o++) {
            0 !== o && (l += ', ')
            try {
              l +=
                '<a href="' +
                e.landingPageUrl +
                encodeURIComponent(decodeURIComponent(u[o])) +
                '" target="_self">' +
                decodeURIComponent(u[o]) +
                '</a>'
            } catch (e) {
              continue
            }
            if (5 == c) break
            c++
          }
        l += '</div>\x3c!-- ends klevuNoResults-popularSearch--\x3e'
      }
      return (l += '</div>\x3c!-- ends klevuNoResults-Inner--\x3e')
    },
    loadLayout: function () {
      'undefined' != typeof klevuLayoutVersion
        ? ((klevu_userOptions.autoComplete = !0),
          'undefined' != typeof klevu_categorySearchEnabled &&
            klevu_categorySearchEnabled &&
            (klevu_userOptions.autoCompleteFilters = 'category'),
          ('undefined' != typeof klevu_cms_module_enabled &&
            klevu_cms_module_enabled &&
            klevu_cmsSearchEnabled) ||
          ('undefined' != typeof klevu_shopifyStore &&
            klevu_shopifyStore &&
            'undefined' != typeof klevu_cmsEnabled &&
            klevu_cmsEnabled) ||
          ('undefined' != typeof klevu_bigCommerceStore &&
            klevu_bigCommerceStore &&
            'undefined' != typeof klevu_cmsEnabled &&
            klevu_cmsEnabled)
            ? ((klevu_userOptions.cmsEnabled = !0),
              (klevu_cmsApiKey = klevu_apiKey),
              klevu_userOptions.autoCompleteFilters.trim().length > 0
                ? (klevu_userOptions.autoCompleteFilters += ':cms')
                : (klevu_userOptions.autoCompleteFilters = 'category:cms'))
            : (klevu_userOptions.cmsEnabled = !1),
          (klevu_userOptions.layoutVersion = '2.0'),
          (klevu_userOptions.recordsPerPage = 3),
          'undefined' != typeof klevu_productsToShowInSlimLayout &&
            (klevu_userOptions.recordsPerPage = klevu_productsToShowInSlimLayout),
          (klevu_userOptions.fetchFilters = !1),
          (klevu_userOptions.rsPsClickBehaviour = 'redirect'),
          'undefined' != typeof klevu_rsPsClickBehaviour &&
            (klevu_userOptions.rsPsClickBehaviour =
              klevu_rsPsClickBehaviour || 'redirect'),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.showResultsData &&
            (klevu_layout.renderResults = klevu_uc.showResultsData),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.addAutocompleteLayoutToPage &&
            (klevu_layoutSetup.addLayoutToPage =
              klevu_uc.addAutocompleteLayoutToPage),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.showAutocompleteProducts &&
            (klevu_layout.displayProductdata =
              klevu_uc.showAutocompleteProducts),
          void 0 !== klevu_uc &&
            void 0 !== klevu_uc.displayNoResultData &&
            (klevu_layout.displayNoResultData = klevu_uc.displayNoResultData),
          klevu_layoutSetup.addLayoutToPage(
            document.getElementsByTagName('body')[0]
          ),
          uc_helperFunctions.focusThirdPartyInput())
        : setTimeout(klevu_loadLayout, 200)
    }
  }
function klevu_afterLandingResultsLoaded (e) {
  uc_helperFunctions.goToCMS(),
    uc_helperFunctions.addBodyClass(),
    screenWidthCheck() ||
      (uc_helperFunctions.moveFilters(),
      uc_helperFunctions.onlyOneFacetOpened()),
    uc_helperFunctions.moveSelectedFilters(),
    uc_helperFunctions.customSelect(),
    uc_helperFunctions.closeFacets(),
    screenWidthCheck() &&
      (uc_helperFunctions.addFilterOpener(),
      uc_helperFunctions.mobFilterContainer(),
      uc_helperFunctions.applyButtonFunctionality(),
      uc_helperFunctions.closeOnApplyClick()),
    uc_helperFunctions.addFilterTopClass(),
    uc_helperFunctions.renameProductTab(),
    uc_helperFunctions.renameCMSTab(),
    uc_helperFunctions.priceRangeRename(),
    uc_helperFunctions.removeFilterClass(),
    uc_helperFunctions.clearFacetFunctionality()
}
function klevu_afterLandingCmsResultsLoaded (e) {
  uc_helperFunctions.renameCMSTab()
}
var uc_helperFunctions = {
  addBodyClass: function () {
    document.getElementsByTagName('body')[0].classList.add('klevu_page')
  },
  addFilterOpener: function () {
    var e =
        'undefined' != typeof klevu_lang && '' !== klevu_lang
          ? klevu_lang
          : 'en',
      t =
        '<div class="ku-filterOpener" onclick="uc_helperFunctions.openCloseFilter()">' +
        ku_translations[e].filterBy +
        '</div>'
    !document.querySelector('.ku-filterOpener') &&
      document.querySelector('.kuSortHeader') &&
      document.querySelector('.kuSortHeader').insertAdjacentHTML('beforeend', t)
  },
  openCloseFilter: function () {
    document
      .getElementsByTagName('body')[0]
      .classList.toggle('kuFilters_opened')
  },
  mobFilterContainer: function () {
    var e =
        'undefined' != typeof klevu_lang && '' !== klevu_lang
          ? klevu_lang
          : 'en',
      t = '\n    <div class="ku-mobFilterContainer">\n    <div class="ku-closeMobFilter" onclick="uc_helperFunctions.openCloseFilter()" >'
        .concat(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M15.314 4l.565.566-5.374 5.373 5.374 5.375-.565.565-5.375-5.374-5.373 5.374L4 15.314l5.374-5.375L4 4.566 4.566 4l5.373 5.374L15.314 4z"/></svg>',
          '</div>\n      <div class="ku-mobFilterContainer-header">\n        \n        <div>'
        )
        .concat(
          ku_translations[e].filterBy,
          '</div>\n      </div>\n      <div class="ku-mobFilterContainer-footer">\n        <button id="applyFilter">'
        )
        .concat(ku_translations[e].apply, '</button>\n      </div>\n    </div>')
    document.querySelector('.ku-mobFilterContainer') ||
      document
        .getElementsByTagName('body')[0]
        .insertAdjacentHTML('beforeend', t),
      document.getElementById('kuFilters') &&
        document.querySelector('.ku-mobFilterContainer') &&
        ((document.getElementById('kuFilters').style.display = 'block'),
        setTimeout(function () {
          document
            .querySelector('.ku-mobFilterContainer')
            .insertAdjacentElement(
              'afterbegin',
              document.getElementById('kuFilters')
            )
        }, 0))
  },
  applyButtonFunctionality: function () {
    var e = ''
    document.querySelectorAll('.kuFilterNames ul li a').forEach(function (t) {
      t.onclick = function (l) {
        l.preventDefault()
        var n = l.target.closest('li'),
          r = document.getElementById('applyFilter').getAttribute('onclick'),
          a = t.getAttribute('onclick')
        n.classList.toggle('kuSelected'),
          null !== r && -1 !== r.indexOf(a)
            ? ((e = e.replace(a, '')),
              document.getElementById('applyFilter').setAttribute('onclick', e))
            : ((e += a),
              document.getElementById('applyFilter').setAttribute('onclick', e))
      }
    })
  },
  customSelect: function () {
    var e, t, l, n, r, a, i
    0 === document.querySelectorAll('.select-selected').length &&
      (function () {
        var s = function (e) {
          var t,
            l,
            n,
            r = []
          for (
            t = document.getElementsByClassName('select-items'),
              l = document.getElementsByClassName('select-selected'),
              n = 0;
            n < l.length;
            n++
          )
            e == l[n] ? r.push(n) : l[n].classList.remove('select-arrow-active')
          for (n = 0; n < t.length; n++)
            r.indexOf(n) && t[n].classList.add('select-hide')
        }
        for (
          e = document.getElementsByClassName('kuSortby'), t = 0;
          t < e.length;
          t++
        ) {
          for (
            n = e[t].getElementsByTagName('select')[0],
              (r = document.createElement('DIV')).setAttribute(
                'class',
                'select-selected'
              ),
              r.innerHTML = n.options[n.selectedIndex].innerHTML,
              e[t].appendChild(r),
              (a = document.createElement('DIV')).setAttribute(
                'class',
                'select-items select-hide'
              ),
              l = 0;
            l < n.length;
            l++
          )
            ((i = document.createElement('DIV')).innerHTML =
              n.options[l].innerHTML),
              i.setAttribute('data-value', n.options[l].value),
              i.addEventListener('click', function (e) {
                var t, l, n, r, a
                for (
                  r = this.parentNode.parentNode.getElementsByTagName(
                    'select'
                  )[0],
                    a = this.parentNode.previousSibling,
                    klevu_changeSortingOptionsForLandigPage(
                      this.getAttribute('data-value')
                    ),
                    l = 0;
                  l < r.length;
                  l++
                )
                  if (r.options[l].innerHTML == this.innerHTML) {
                    for (
                      r.selectedIndex = l,
                        a.innerHTML = this.innerHTML,
                        t = this.parentNode.getElementsByClassName(
                          'same-as-selected'
                        ),
                        n = 0;
                      n < t.length;
                      n++
                    )
                      t[n].removeAttribute('class')
                    this.setAttribute('class', 'same-as-selected')
                    break
                  }
                a.click()
              }),
              a.appendChild(i)
          e[t].appendChild(a),
            r.addEventListener('click', function (e) {
              document.querySelectorAll('.select-items > .same-as-selected')
                .length <= 0 &&
                document
                  .querySelectorAll('.select-items > div')[0]
                  .classList.add('same-as-selected'),
                e.stopPropagation(),
                s(this),
                this.nextSibling.classList.toggle('select-hide'),
                this.classList.toggle('select-arrow-active')
            })
        }
        document.addEventListener('click', s)
      })()
  },
  moveFilters: function () {
    document.getElementById('kuFilters') &&
      document.querySelector('.kuSortHeader') &&
      !document.querySelector('.kuSortHeader #kuFilters') &&
      document
        .querySelector('.kuSortHeader')
        .insertAdjacentElement(
          'afterbegin',
          document.getElementById('kuFilters')
        )
  },
  moveSelectedFilters: function () {
    document.getElementById('ku-search-filter-tags') &&
      document.querySelector('.kuSortHeader') &&
      !document.querySelector('#kuProductContent #ku-search-filter-tags') &&
      document
        .querySelector('.kuSortHeader')
        .insertAdjacentElement(
          'afterend',
          document.getElementById('ku-search-filter-tags')
        )
  },
  closeFacets: function () {
    Array.prototype.slice
      .call(document.querySelectorAll('#kuFilters .kuFilterHead'))
      .forEach(function (e) {
        ;(e.parentElement.style.height = '50px'),
          e.classList.remove('kuCollapse'),
          e.classList.add('kuExpand'),
          (e.nextElementSibling.style.cssText = 'display: none;')
      })
  },
  closeOnApplyClick: function () {
    document.getElementById('applyFilter') &&
      document
        .getElementById('applyFilter')
        .addEventListener('click', function () {
          document
            .getElementsByTagName('body')[0]
            .classList.remove('kuFilters_opened')
        })
  },
  goToCMS: function () {
    var e = new URL(window.location.href)
    if ('true' === e.searchParams.get('goToCMS')) {
      e.searchParams.delete('goToCMS')
      var t = e.toString()
      window.history.replaceState(null, null, t), klevu_changeKuTab('other')
    }
  },
  ifNoResults: function (e, t) {
    0 === e
      ? document.getElementById('klevuSearchingArea').classList.add(t)
      : document.getElementById('klevuSearchingArea').classList.remove(t)
  },
  addFilterTopClass: function () {
    document.getElementById('kuMainContainer') &&
      (document
        .getElementById('kuMainContainer')
        .classList.remove('kuFiltersLeft'),
      document.getElementById('kuMainContainer').classList.add('kuFiltersTop'))
  },
  changeImageSize: function (e, t, l) {
    try {
      e.image &&
        (e.image = -1 !== e.image.indexOf(l) ? e.image.replace(l, t) : e.image),
        e.imageUrl &&
          (e.imageUrl =
            -1 !== e.imageUrl.indexOf(l)
              ? e.imageUrl.replace(l, t)
              : e.imageUrl),
        e.imageHover &&
          (e.imageHover =
            -1 !== e.imageHover.indexOf(l)
              ? e.imageHover.replace(l, t)
              : e.imageHover),
        (e.productImage = e.image)
    } catch (e) {
      console.log(e)
    }
  },
  renameProductTab: function () {
    if (document.getElementById('kuProductTab')) {
      var e =
        'undefined' != typeof klevu_lang && '' !== klevu_lang
          ? klevu_lang
          : 'en'
      document.getElementById('kuProductTab').innerHTML =
        ku_translations[e].products +
        ' (' +
        klevu_pagination.totalLandingResultsFound +
        ')'
    }
  },
  renameCMSTab: function () {
    if (document.getElementById('kuOtherTab')) {
      var e =
        'undefined' != typeof klevu_lang && '' !== klevu_lang
          ? klevu_lang
          : 'en'
      klevu_pagination.totalLandingCmsResultsFound > 0
        ? (document.getElementById('kuOtherTab').innerHTML =
            ku_translations[e].blog +
            ' (' +
            klevu_pagination.totalLandingCmsResultsFound +
            ')')
        : (document.getElementById('kuOtherTab').innerHTML =
            ku_translations[e].blog)
    }
  },
  priceRangeRename: function () {
    document.getElementById('kuFilterHead-Price_Range') &&
      (document.getElementById('kuFilterHead-Price_Range').innerText =
        'Price Range')
  },
  closeQuickSearch: function () {
    document.getElementById('klevuSearchingArea') &&
      (document.getElementById('klevuSearchingArea').style.display = 'none')
  },
  removeFilterClass: function () {
    document.getElementById('kuMainContainer') &&
      (document
        .getElementById('kuMainContainer')
        .classList.remove('kuFiltersTop'),
      document.getElementById('kuMainContainer').classList.add('kuFiltersLeft'))
  },
  clearFacetFunctionality: function () {
    document.querySelectorAll('.kuSelected').length > 0 &&
      Array.prototype.slice
        .call(document.querySelectorAll('.kuFilterBox'))
        .forEach(function (e) {
          var t = ''
          e.querySelectorAll('.kuSelected').length > 0 &&
            e.classList.add('ku-contain-selected'),
            Array.prototype.slice
              .call(e.querySelectorAll('.kuSelected'))
              .forEach(function (l) {
                ;(t += l.firstElementChild.getAttribute('onclick')),
                  e.querySelector('.ku-clear-facet').setAttribute('onclick', t)
              })
        })
  },
  scrollToProduct: function () {
    var e = new URL(window.location.href),
      t = e.searchParams
    if (null !== e.searchParams.get('scrollTo')) {
      var l = t.get('scrollTo')
      window.scrollTo(0, l)
    }
    if (null !== e.searchParams.get('scrollTo')) {
      t.delete('scrollTo')
      var n = e.toString()
      history.pushState(-1, 'title', n)
    }
  },
  addScrollToParameterToURL: function () {
    if (
      window.history &&
      history.pushState &&
      document.getElementById('kuLandingProductsListUl')
    ) {
      document
        .getElementById('kuLandingProductsListUl')
        .removeEventListener('click', e)
      var e = function (e) {
        try {
          if ('kuLandingProductsListUl' !== e.target.id) {
            var t = (function e (t) {
              return 'LI' === t.tagName ? t : t.parentNode && e(t.parentNode)
            })(e.target)
            if ('LI' === t.tagName) {
              var l = new URL(window.location.href),
                n = l.searchParams,
                r = Math.round(window.pageYOffset + t.getBoundingClientRect().y)
              if (null === l.searchParams.get('scrollTo')) {
                n.append('scrollTo', r)
                var a = l.toString()
                history.pushState(-1, 'title', a)
              } else {
                n.set('scrollTo', r)
                var i = l.toString()
                history.pushState(-1, 'title', i)
              }
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
      document
        .getElementById('kuLandingProductsListUl')
        .addEventListener('click', e)
    }
  },
  focusThirdPartyInput: function () {
    try {
      var e = document.getElementById('klevu-pt-rs-hover'),
        t = document.getElementById('klevuSearchingArea'),
        l = document.getElementById('ku-search-field'),
        n = document.getElementsByTagName('body')[0]
      null !== l &&
        l.addEventListener('click', function () {
          n.classList.add('klevu-upon-third-party-input')
        })
      var r = new MutationObserver(function (e, t) {
        var r = !0,
          a = !1,
          i = void 0
        try {
          for (
            var s, o = e[Symbol.iterator]();
            !(r = (s = o.next()).done);
            r = !0
          ) {
            var u = s.value
            u.attributeName && 'none' !== u.target.style.display
              ? (n.classList.add('klevu-quick-autocomplete'),
                null !== l &&
                  l === document.activeElement &&
                  n.classList.add('klevu-upon-third-party-input'))
              : 'block' !== u.target.style.display &&
                (n.classList.remove('klevu-quick-autocomplete'),
                n.classList.remove('klevu-upon-third-party-input'))
          }
        } catch (e) {
          ;(a = !0), (i = e)
        } finally {
          try {
            r || null == o.return || o.return()
          } finally {
            if (a) throw i
          }
        }
      })
      r.observe(e, { attributes: !0 }), r.observe(t, { attributes: !0 })
    } catch (e) {
      console.log('KLEVU Mutation observer error', e)
    }
  },
  onlyOneFacetOpened: function () {
    function e (e) {
      e.target.classList.contains('kuCollapse') &&
        (uc_helperFunctions.closeFacets(),
        (e.target.parentElement.style.height = 'auto'),
        e.target.classList.add('kuCollapse'),
        e.target.classList.remove('kuExpand'),
        (e.target.nextElementSibling.style.cssText = 'display: block;'))
    }
    document.getElementById('kuFilters').removeEventListener('click', e),
      document.getElementById('kuFilters').addEventListener('click', e)
  }
}
function klevu_uc_productCustomizations (e) {
  return uc_helperFunctions.changeImageSize(e, '_400x800', '_medium'), e
}
function screenWidthCheck (e) {
  return (
    e || (e = 767),
    (window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth) <= e
  )
}
/* eslint-enable */
